<template>
  <span
      class="STATUS-BUBBLE ellipsize">
    {{ statusLabel }}
  </span>
</template>

<script>
import { SUB_STATUS_OPTIONS } from '@/constants/sub-status-options';

export default {
  SUB_STATUS_OPTIONS,
  name: 'sub-status-bubble',
  props: {
    status: String,
  },
  computed: {
    statusLabel () {
      if (!this.status) {
        return 'Select Status';
      }
      const normalizedStatus = this.status.trim().toLowerCase();
      const matchedOption = Object.values(this.$options.SUB_STATUS_OPTIONS).find(
        ({ text, sub_status_name }) => text.trim().toLowerCase() === normalizedStatus
          || sub_status_name === this.status
      );

      return matchedOption ? matchedOption.sub_status_short_description : 'Select Status';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .STATUS-BUBBLE {
    @include text-small;
    max-width: 100%;
    align-items: center;
    height: 3*$unit;
    padding: $unit/3 $unit;
    color: $color-gray70;
    font-weight: 400;
    background-color: $color-gray20;
    border-radius: 2*$unit;
    border: 1px solid $color-gray70;
    text-transform: uppercase;
    will-change: color, background-color;
    transition: color $transition-half-duration,
      background-color $transition-half-duration;
  }
</style>
